$ = require 'jquery'
{ Key } = require '@trello/keybindings'
_ = require 'underscore'
log = require 'app/scripts/debug/log'
parseURL = require 'url-parse'
Promise = require 'bluebird'
{
  tryToExcludeEXIFRotated
  preferScaledPreviews
  smallestPreviewBiggerThan
  previewBetween
  biggestPreview
  smallestPreview
  smallestPreviewBetween
} = require 'app/common/lib/util/preview'
{ usesEnglish } = require '@trello/locale'

module.exports = Util =
  spacing:    16384              # 2^14

  checkId: (value) -> value?.constructor.name == 'ObjectID' || (value?.length == 24 && ///^[a-f0-9]*$///.test(value))

  capitalize: (val) ->
    if _.isString(val) && !_.isEmpty(val)
      val[0].toUpperCase() + val.substr(1)
    else
      val

  pluralize: (val) ->
    "#{ val }s"

  imageFileExtensions: ['png', 'gif', 'jpg', 'jpeg', 'bmp', 'ico']

  extensionIsImage: (fileName) ->
    Util.fileExt(fileName)?.toLowerCase() in Util.imageFileExtensions

  fileExt: (val) ->
    /\.([a-z0-9]+)$/i.exec(val)?[1]?.toLowerCase() ? null

  traverse: (obj, path) ->
    if _.isEmpty(path) || !obj
      return obj

    if _.isArray(path)
      for key in path
        obj = obj[key]
        break if !obj

      obj
    else
      obj[path]

  # via http://simonwillison.net/2006/Jan/20/escape/
  escapeForRegex: (text) -> text?.replace(/[-[\]{}()*+?.,\\\/^$|#\s]/g, '\\$&')

  makeSlug: (s, sep = '-') ->
    if s
      slug = Util.removeAccents(s.toLowerCase()).replace(/[^a-z0-9]+/ig, sep).replace(///^#{sep}|#{sep}$///g, "")

      if slug.length > 128
        slug = slug.substr(0, 128)

    slug || sep

  removeAccents: (s) ->
    # NOTE: If this starts to get too complicated, we might consider using
    # a unicode normalization library
    s
    .replace(/[àáâãäåāăą]/g,  'a')
    .replace(/æ/g,            'ae')
    .replace(/[çćĉċč]/g,      'c')
    .replace(/[ďđ]/g,         'd')
    .replace(/[èéêëēĕėęě]/g,  'e')
    .replace(/[ĝğġģ]/g,       'g')
    .replace(/[ĥħ]/g,         'h')
    .replace(/[ìíîïĩīĭįı]/g,  'i')
    .replace(/[ñńņňŉŋ]/g,     'n')
    .replace(/[òóôõöōŏő]/g,   'o')
    .replace(/œ/g,            'oe')
    .replace(/ř/g,            'r')
    .replace(/[śŝşš]/g,       's')
    .replace(/ß/g,            'ss')
    .replace(/[ùúûüũūŭůűų]/g, 'u')
    .replace(/[ýÿ]/g,         'y')

  isShortId: (s) -> /^[0-9]{1,8}$/.test(s)
  isShortLink: (s) -> _.isString(s) && /^[a-zA-Z0-9]{8}$/.test(s)

  getTime: ->
    if performance?.now?
      performance.now()
    else
      +(new Date())

  getMs: ({ days, hours, minutes, seconds, ms, years, months, weeks }) ->
    days ?= 0
    hours ?= 0
    minutes ?= 0
    seconds ?= 0
    ms ?= 0

    days += years * 365 if years
    days += months * 30 if months
    days += weeks * 7 if weeks

    hours += days * 24
    minutes += hours * 60
    seconds += minutes * 60

    ms += seconds * 1000
    return ms

  getSeconds: (args) ->
    return @getMs(args) / 1000

  dateAfter: (args) ->
    date = args?.date ? new Date()
    return new Date(date.getTime() + @getMs(args))

  dateBefore: (args) ->
    date = args?.date ? new Date()
    return new Date(date.getTime() - @getMs(args))

  compareMemberType: (board, memberA, memberB, opts = {}) ->
    { mode } = opts
    mode ?= 'standard'

    switch mode
      when 'members'
        hierarchy = [
          ['normal', 'admin']
        ]
      when 'commentDelete'
        hierarchy = [
          ['normal', 'org', 'observer']
          ['admin']
        ]
      else
        hierarchy = [
          ['org']
          ['normal']
          ['admin']
        ]

    getHierarchyLevel = (member) ->
      memberType = board.getMemberType(member)

      # Find the index of the group that this member's memberType is in.
      # (A group may contain multiple member types, e.g. in 'members' mode)
      for group, index in hierarchy
        if memberType in group
          return index

      return -1

    # NOTE: If their memberType isn't in the list, it will be -1, which is lower than everything
    memberALevel = getHierarchyLevel(memberA)
    memberBLevel = getHierarchyLevel(memberB)

    if memberALevel > memberBLevel
      1
    else if memberALevel < memberBLevel
      -1
    else
      0

  idToDate: (id) -> new Date(1000 * parseInt(id?.substr(0, 8), 16))

  tryToExcludeEXIFRotated: tryToExcludeEXIFRotated
  preferScaledPreviews: preferScaledPreviews
  smallestPreviewBiggerThan: smallestPreviewBiggerThan
  previewBetween: previewBetween
  smallestPreviewBetween: smallestPreviewBetween
  biggestPreview: biggestPreview
  smallestPreview: smallestPreview

  # Move items from the end of an array to the beginning, and vice versa.
  # Example: rotateArr([1, 2, 3], 1)  === [3, 1, 2]
  #          rotateArr([1, 2, 3], -1) === [2, 3, 1]
  rotateArr: (arr, shift) ->
    _.flatten [arr[-shift...], arr[0...-shift]], true

  stopPropagation: (e) ->
    e?.stopPropagation()

  preventDefault: (e) ->
    e?.preventDefault()

  stop: (e) ->
    Util.stopPropagation(e)
    Util.preventDefault(e)

  # email

  checkEmail: (email, additionalChars = "") ->
    ///
      ^
      [^"@\s\[\]\(\),:;<>\\]+ # Some stuff before the @
      @
      [-a-z0-9\.#{ additionalChars }]+ # The domain, possibly with subdomains
      \.
      [a-z#{ additionalChars }]+ # The TLD
      $
    ///i.test(email)

  removeDomainFromEmailAddress: (email, additionalChars = "") ->
    email.replace(
      ///
        @
        [-a-z0-9\.#{ additionalChars }]+ # The domain, possibly with subdomains
        \.
        [a-z#{ additionalChars }]+ # The TLD
        $
      ///, "")

  validName: (name) -> name.length >= 1

  spaces: (count) ->
    if !@longStr
      @longStr = " "

    while @longStr.length < count
      @longStr = @longStr + @longStr

    return @longStr.substr(0, count)

  _pad: (str, len, padChr = ' ', leftPad) ->
    # Pad doesn't make much sense on non-strings, does it?
    str = str.toString()

    if str.length > len
      str.substr(0, len)
    else
      amtPadding = len - str.length
      # Optimize for spaces, since that's most common and str concat is expensive
      padding = if padChr == ' ' then @spaces(amtPadding) else @times(padChr, amtPadding)
      if leftPad
        padding + str
      else
        str + padding

  rpad: (str, len, padChr) ->
    @_pad(str, len, padChr, false)

  lpad: (str, len, padChr) ->
    @_pad(str, len, padChr, true)

  times: (str, times) ->
    _.map([0...times], -> str).join('')

  truncate: (s, len) ->
    if !s?.length || s.length < len
      s
    else
      # Try to break at a space
      truncated = s.substr(0, s.lastIndexOf(" ", len))
      if truncated
        truncated
      else
        # Whoops, we would have displayed nothing
        s.substr(0, len)

  usesEnglish: usesEnglish

  scrollToTop: ->
    $(window).scrollTop(0)

  getProtocol: (url) ->
    return '' if !url
    ///^ ([a-z]+): ///i.exec(url)?[1] ? ''

  makeHttp: (url) ->
    return '' if !url
    url = url.replace(/^[a-z]*:\/*/i, '')
    "http://#{url}"

  sanitizeWebAddress: (url) ->
    if Util.getProtocol(url) not in ['http', 'https']
      Util.makeHttp(url)
    else
      url

  isInPosition: (index, allItems, item) ->
    if !item?.id?
      return false
    itemAtPosition = allItems[index]
    itemAtPosition?.id == item.id

  calcPos: (index, allItems, item, fxFilter, includeItem) ->
    indexStep = 65536 # 2^16
    items = allItems.select (c) ->
      (!(item? && item.id == c.id) || includeItem) && (!fxFilter || fxFilter(c))

    # if the item is in position no point in moving it around
    if Util.isInPosition(index, items, item)
      return item.pos ? item.get('pos')

    indexBounded = Math.min(Math.max(index, 0), items.length)

    itemPrev = items[indexBounded - 1]
    itemNext = items[indexBounded]

    posItemCurr = item?.get('pos') || -1

    posItemPrev = if itemPrev? then itemPrev.get('pos') else -1
    posItemNext = if itemNext? then itemNext.get('pos') else -1

    if (posItemNext == -1)
      # Ensure that the new pos comes after the prev card pos
      if (item && posItemCurr > posItemPrev)
        # it's already after so no need to update
        posItemCurr
      else
        # bump it one past the last item
        posItemPrev + indexStep
    else
      if (item && posItemCurr > posItemPrev && posItemCurr < posItemNext)
        posItemCurr
      else if posItemPrev >= 0
        (posItemNext + posItemPrev) / 2
      else
        # halve the pos of the top item
        posItemNext / 2



  randomWait: (wait, spread) ->
    return Math.floor(wait + Math.random() * spread)

  toTitleCase: (str) ->
    return str.replace(/\w\S*/g, (txt) -> return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())

  calcBoardLayout: ->
    $(window).trigger 'resize'

  # nav menu list

  navMenuList: (parentEl, item, key) ->

    items = parentEl.find(item)

    selectedEl = items.filter('.selected').first()[0]
    sIndex = _.indexOf(items, selectedEl)

    firstEl = items[0]
    lastEl  = items[items.length - 1]


    if sIndex - 1 < 0
      prevEl = lastEl
    else
      prevEl = items[sIndex - 1]

    if sIndex + 1 > items.length
      nextEl = firstEl
    else
      nextEl = items[sIndex + 1]


    if key == Key.ArrowDown
      elem = nextEl

    if key == Key.ArrowUp
      elem = prevEl

    @selectMenuItem(parentEl, item, elem)


  selectMenuItem: (parentEl, items, elem) ->
    parentEl.find(items).removeClass('selected')
    $(elem).addClass('selected')

  # selection

  insertSelection: (textarea, newtext, start, end) ->
    textarea = Util.getElem(textarea)
    $textarea = $(textarea)
    val = $textarea.val()

    if start? || end?
      before = val.substring(0, start)
      after = val.substring(end)
      @setCaretPosition(textarea, start + "#{newtext}".length)

    else
      before = val
      after = ""

    if /\S$/.test(before)
      separator = ' '
    else
      separator = ''

    $textarea.val before + separator + newtext + after
    @setCaretPosition(textarea, before.length + separator.length + newtext.length)

    $textarea.focus()
    $textarea.trigger('mutated')

  _nextWhitespace: (val, idx) ->
    nextBreak = val.indexOf('\n', idx)
    if nextBreak == -1 then nextBreak = Infinity
    nextSpace = val.indexOf(' ', idx)
    if nextSpace == -1 then nextSpace = Infinity

    Math.min(nextBreak, nextSpace, val.length)

  # Find the word from the previous word break up until the cursor
  getWordFromIndex: (val, idx) ->

    # get the most recent word break
    start = Math.max(val.lastIndexOf('\n', idx - 1), val.lastIndexOf(' ', idx - 1))
    start += 1

    # trim obvious punctuation from the start of the word
    # handle : specially since it can be used for emoji, but we don't want it
    # to interfere with @mentions (e.g. cc:@someone)
    while /[()\[\]\/\\;"'&]|:@/.test(val[start])
      start++

    end = idx

    length = end - start
    str = val.slice(start, end)

    return {
      start: start
      end: end
      length: length
      str: str
    }

  getWordFromCaret: (textarea) ->
    textarea = Util.getElem(textarea)

    val = $(textarea).val()
    idx = @getCaretPosition(textarea)

    @getWordFromIndex(val, idx)

  getLineFromIndex: (val, idx) ->
    # get the most recent line break
    start = val.lastIndexOf('\n', idx - 1)
    start += 1

    end = @_nextWhitespace(val, idx)

    length = end - start
    str = val.slice(start, end)

    return {
      start: start
      end: end
      length: length
      str: str
    }

  getLineFromCaret: (textarea) ->
    textarea = Util.getElem(textarea)

    val = $(textarea).val()
    idx = @getCaretPosition(textarea)

    @getLineFromIndex(val, idx)


  getCaretPosition: (textarea) ->
    textarea = Util.getElem(textarea)

    if textarea.selectionStart?
      caretPos = textarea.selectionStart
    else if 'selection' in document
      #IE support
      textarea.focus()
      selection = document.selection.createRange()
      selectionLength = document.selection.createRange().text.length
      selection.moveStart('character', -textarea.value.length)
      caretPos = selection.text.length - selectionLength

    caretPos

  setCaretPosition: (ctrl, pos) ->
    ctrl = Util.getElem(ctrl)

    if ctrl.setSelectionRange
      ctrl.focus()
      ctrl.setSelectionRange(pos, pos)
    else if ctrl.createTextRange
      range = ctrl.createTextRange()
      range.collapse(true)
      range.moveEnd('character', pos)
      range.moveStart('character', pos)
      range.select()

  setCaretAtEnd: (input) ->
    if input
      end = $(input).val().length
      @setCaretPosition(input, end)

  getLastWord: (textarea) ->
    terms = $(textarea).val().split(' ')
    return _.last(terms)

  removeWordAtIndex: (val, idx) ->
    word = Util.getWordFromIndex(val, idx)
    first = val.slice(0, word.start)
    last = val.slice(word.end)
    first + last

  stripExtraSpaces: (string) ->
    string?.replace(/\s+/g, " ").trim()

  # members

  getMemNameArray: (mem) ->
    _.chain(['username', 'fullName', 'initials', 'email'])
     .map (attr) -> mem.get(attr)?.toLowerCase().split(/\s+/)
     .compact()
     .flatten()
     .value()

  getMemNameArrayFromId: (modelCache, id) ->
    if (mem = modelCache.get('Member', id))?
      @getMemNameArray(mem)
    else
      []

  filterMembers: (modelCache, term, idMems) ->
    termRe = ///^#{Util.escapeForRegex(term)}///i

    idMatchMems = []
    for memId in idMems
      splitNames = Util.getMemNameArrayFromId(modelCache, memId)
      if _.find(splitNames, (name) -> termRe.test(name))
        idMatchMems.push(memId)

    return idMatchMems

  getQueryParameter: (name, defaultValue = "") ->
    paramRegex = /// [?&] #{ name } = ([^?&]*) ///
    match = paramRegex.exec(location.search) ? paramRegex.exec(location.hash)
    value = match?[1]
    if value?
      decodeURIComponent(value.replace(/\+/g, " "))
    else
      defaultValue

  validFileSize: (file, limit = 10 * 1024 * 1024) ->
    file?.size < limit

  uploadFile: (token, input, next) ->
    name = _.uniqueId('iframe')

    elIframe = $('<iframe>')
    .attr('name', name)
    .css('display', 'none')
    .appendTo('body')
    .load (e) ->
      _.defer -> elIframe.remove()
      try
        response = elIframe.contents().text()
      catch error
        # If we're in IE and the response is anything other than 200, the iframe
        # ends up in a different security domain and we can't read its contents
        return next("File too large")
      if /File too large/i.test(response)
        next(response)
      else
        next()

    input.closest('form')
    .attr('target', name)
    .find('input[name=token]')
      .val(token)
      .end()
    .submit()

    _.defer -> input.val("")

  hasValidInviteTokenFor: (model) ->
    inviteToken = @inviteTokenFor(model.id)
    if !inviteToken?
      return false

    ghostMember = model.modelCache.get('Member', inviteToken.split('-')[0])
    if !ghostMember?
      return false
    if model.getMemberType(ghostMember) == 'virtual'
      return true

    return model.isMember(ghostMember) && model.get('memberType') == 'ghost'

  inviteTokenFor: (idModel) -> $.cookie("invite-token-#{idModel}")

  invitationTokens: ->
    inviteRegex = /invite-token-[-a-f0-9]*/g
    while (cookieName = inviteRegex.exec(document.cookie)?[0])?
      $.cookie(cookieName)

  # Normalize an input parameter to
  getElem: (jqOrElem) ->
    if jqOrElem instanceof $
      jqOrElem[0]
    else
      jqOrElem

  # A polyfill for getting transforms objects. It's not possible to get
  # individual parts of a transform like scale, rotate, translate, etc. so we
  # have to get the whole transform matrix then get individual parts.
  getElemTransformMatrix: (elem) ->
    matrix = elem.css('-webkit-transform') ||
      elem.css('-moz-transform')    ||
      elem.css('-ms-transform')     ||
      elem.css('-o-transform')      ||
      elem.css('transform')

    # JavaScript returns a "none" string if there is not transform... so
    # let's return null instead so we can check for existence later.
    if matrix != 'none'
      matrix
    else
      null

  getMatrixDegrees: (matrix) ->
    values = matrix.split('(')[1].split(')')[0].split(',')
    a = values[0]
    b = values[1]
    c = values[2]
    d = values[3]
    Math.round(Math.atan2(b, a) * (180 / Math.PI))

  getMatrixScale: (matrix) ->
    values = matrix.split('(')[1].split(')')[0].split(',')
    a = values[0]
    b = values[1]
    c = values[2]
    d = values[3]
    Math.sqrt(a * a + b * b)

  getDegrees: (y, x) ->
    Math.round(Math.atan2(y, x) * (180 / Math.PI))

  getPositiveDegrees: (y, x) ->
    (Util.getDegrees(y, x) + 360) % 360

  # http://jsfiddle.net/chriscoyier/t5Kts/
  calcDistanceFromCenter: (elem, mouseX, mouseY) ->
    distanceSquared = Math.pow(mouseX - (elem.offset().left + (elem.width() / 2)), 2) +
                      Math.pow(mouseY - (elem.offset().top + (elem.height() / 2)), 2)

    Math.floor(Math.sqrt(distanceSquared))

  # Help the Garbage Collector out by detatching everything from the object
  # We wait a bit (for all the callbacks, etc to fire) to avoid any issues
  # with callbacks that might be firing at the same time as our transition
  _runShredders: ->
    shredders = Util._shredders
    now = new Date()
    Util._shredders = []
    count = 0
    for entry in shredders
      if now > entry.time
        entry.fn()
        count++
      else
        Util._shredders.push(entry)

    log('shred', "Shred #{ count } objects, #{ Util._shredders.length } left")

    Util._shredTimeout = null
    Util._startShredTimer()

  _startShredTimer: ->
    if !Util._shredTimeout && Util._shredders.length > 0
      Util._shredTimeout ?= setTimeout Util._runShredders, Util.getMs(seconds: 3)

  shred: (obj) ->
    Util._shredders ?= []
    Util._shredders.push
      time: Util.dateAfter(seconds: 20)
      fn: =>
        for own key of obj
          delete obj[key]

    Util._startShredTimer()

  extendEvents: (events) ->
    -> _.defaults(events, _.result(@constructor.__super__, 'events'))

  relativeUrl: (url) ->
    url.replace /// ^ #{ siteDomain } ///, ""

  isTextElement: (el) ->
    # Because input[type=text] and input[type=submit] are both instances of
    # HTMLInputElement, the spec requires that accessing the properties of
    # non-text type inputs throw an exception, and provides no way to detect
    # whether the element is actually textual. We attempt to short-circuit
    # for common known types, but to support new input types being added or
    # unknown types falling back to text input, the final word is hacky
    # exception testing.
    # See http://www.w3.org/TR/html5/forms.html#textFieldSelection

    if el instanceof HTMLTextAreaElement
      return true

    if el not instanceof HTMLInputElement
      return false

    if el.type in ['text', 'email', 'password', 'search']
      return true

    if el.type in ['submit', 'reset', 'button', 'checkbox']
      return false

    try
      el.selectionStart
      return true
    catch
      return false

  withoutAlteringSelection: (body) ->
    activeElement = document.activeElement
    $activeElement = $(activeElement)
    focused = $activeElement.is(':focus')
    if activeElement? && Util.isTextElement(activeElement)
      if activeElement.selectionStart
        start = activeElement.selectionStart
        end = activeElement.selectionEnd
        direction = activeElement.selectionDirection
      else
        startCompatibility = @getCaretPosition(activeElement)
      body()
      if start
        activeElement.setSelectionRange(start, end, direction)
      else if startCompatibility
        @setCaretPosition(activeElement, startCompatibility)

      if focused then $activeElement.focus()
    else
      body()
    return

  extendParentClassName: (className) ->
    -> _.result(@constructor.__super__, 'className') + " #{className}"

  waitForImageLoad: (url) ->
    new Promise (resolve, reject) ->
      img = new Image()
      img.onload = ->
        resolve(img)
      img.onerror = ->
        reject(img)
      img.src = url

  # Sort members alphabetically, with a special member first
  sortMembers: (members, first) ->
    isFirst = (memberLikeThing) ->
      memberLikeThing == first ||
      memberLikeThing.id == first.get('id')
    members.sort (memA, memB) ->
      aFirst = isFirst memA
      bFirst = isFirst memB
      if aFirst && !bFirst
        -1
      else if !aFirst && bFirst
        1
      else if memA.fullName < memB.fullName
        -1
      else if memA.fullName > memB.fullName
        1
      else
        0
    members

  # due date stuff
  firstLessThan: (n, dispatch) ->
    for entry in dispatch
      if _.isArray(entry)
        [cutoff, val] = entry
        if n <= cutoff
          if _.isFunction(val)
            return val.call(@, n)
          else
            return val
      else
        if _.isFunction(entry)
          return entry.call(@, n)
        else
          return entry
    return

  hoursLeft: (date) ->
    (new Date(date) - new Date()) / Util.getMs(hours: 1)

  escapedReturnUrl: ->
    encodeURIComponent(location.href.replace(/// ^ https?://[^/]+ ///, ""))

  # Determine if a URL is not part of the web client
  isExternalURL: (url) ->
    parsed = parseURL(url)
    # A mismatched host is obviously external; also reject anything that
    # looks like it might be an attempt at a protocol relative URL
    # (i.e. two //, or something tricky like /\)  Also consider anything
    # with a /. or .. in it to be external
    (parsed.host != document.location.host) || ///^ [\\/.]{2,} ///.test(parsed.pathname)

  reverse: (array) -> array.slice(0).reverse()

  buildFuzzyMatcher: (query) ->
    searchExpressions = _.map query.split(/\s+/), (word) ->
      ///#{ Util.escapeForRegex(word) }///i
    return (input) ->
      _.every searchExpressions, (searchExpression) ->
        searchExpression.test input

  getPadding: (el) ->
    paddings = $(el).css [
      'padding-left',
      'padding-top',
      'padding-bottom',
      'padding-right'
    ]
    left: parseInt(paddings['padding-left'], 10)
    top: parseInt(paddings['padding-top'], 10)
    bottom: parseInt(paddings['padding-bottom'], 10)
    right: parseInt(paddings['padding-right'], 10)

  frameInCoordinateSpace: (childEl, parentEl) ->
    parentPadding = Util.getPadding parentEl
    childFrame =
      top: childEl.offsetTop - (parentEl.offsetTop + parentPadding.top)
      left: childEl.offsetLeft - (parentEl.offsetLeft + parentPadding.left)
    childFrame.bottom = childFrame.top + childEl.clientHeight
    childFrame.right = childFrame.left + childEl.clientWidth
    return childFrame

  getBounds: (el) ->
    $el = $(el)
    bounds =
      left: $el.scrollLeft()
      top: $el.scrollTop()
      width: $el.innerWidth()
      height: $el.innerHeight()
    bounds.bottom = bounds.top + bounds.height
    bounds.right = bounds.left + bounds.width
    return bounds

  scrollElementIntoView: (parentEl, childEl, { horizontal, vertical, animated } = {}) ->
    parentBounds = Util.getBounds(parentEl)
    parentPadding = Util.getPadding(parentEl)
    childFrame = Util.frameInCoordinateSpace(childEl, parentEl)
    frameWeWantVisible =
      top: childFrame.top - parentPadding.top
      bottom: childFrame.bottom + parentPadding.bottom
      left: childFrame.left - parentPadding.left
      right: childFrame.right + parentPadding.right

    set = if animated
      $parentEl = $(parentEl)
      (prop, val) ->
        map = {}
        map[prop] = val
        $parentEl.animate map, { duration: 150, queue: false }
    else
      (prop, val) ->
        parentEl[prop] = val

    if vertical
      scrollVertical = (top) ->
        set 'scrollTop', top + parentPadding.top
      if frameWeWantVisible.bottom > parentBounds.bottom
        scrollVertical frameWeWantVisible.bottom - parentBounds.height
      else if frameWeWantVisible.top < parentBounds.top
        scrollVertical frameWeWantVisible.top
    if horizontal
      scrollHorizontal = (left) ->
        set 'scrollLeft', left + parentPadding.left
      if frameWeWantVisible.right > parentBounds.right
        scrollHorizontal frameWeWantVisible.right - parentBounds.width
      else if frameWeWantVisible.left < parentBounds.left
        scrollHorizontal frameWeWantVisible.left
    return

  loadScript: (url) ->
    new Promise (resolve, reject) ->
      scriptEl = document.createElement('script')
      scriptEl.async = true
      scriptEl.src = url
      scriptEl.onload = resolve
      scriptEl.onerror = reject
      document.querySelector('head').appendChild(scriptEl)

  isJsonString: (str) ->
    try JSON.parse(str)
    catch e then false
    finally true

  calculateBrightness: (hex) ->
    # Ignoring the leading # character.
    r = parseInt(hex.substr(1, 2), 16)
    g = parseInt(hex.substr(3, 2), 16)
    b = parseInt(hex.substr(5, 2), 16)

    # As defined in https://www.w3.org/TR/AERT/#color-contrast
    brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000

    if brightness > 127.5
      return 'light'

    return 'dark'

  parseImageLink: (link, p) ->
    url = parseURL(link, true)
    _.extend(url.query, p)

    url.toString()
